var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Popover",
    {
      ref: "popover",
      attrs: {
        open: _vm.isVisible,
        "auto-hide": false,
        placement: _vm.placement,
        "boundaries-element": _vm.boundaryElement,
        "open-class": "event-popover",
        trigger: "manual"
      }
    },
    [
      _vm.isLoading ? _c("PopoverLoadingIndicator") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "event-popover__top-right-actions" },
        [
          !_vm.isLoading && _vm.isReadOnly
            ? _c(
                "Actions",
                [
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-fullscreen" },
                      on: { click: _vm.showMore }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Show more details")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "Actions",
                [
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-close" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Close")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("IllustrationHeader", {
            attrs: {
              color: _vm.illustrationColor,
              "illustration-url": _vm.backgroundImage
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("PropertyTitle", {
            attrs: { value: _vm.title, "is-read-only": _vm.isReadOnly },
            on: { "update:value": _vm.updateTitle }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.showCalendarPicker
        ? _c("PropertyCalendarPicker", {
            attrs: {
              calendars: _vm.calendars,
              calendar: _vm.selectedCalendar,
              "is-read-only": _vm.isReadOnly
            },
            on: { selectCalendar: _vm.changeCalendar }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("PropertyTitleTimePicker", {
            attrs: {
              "start-date": _vm.startDate,
              "start-timezone": _vm.startTimezone,
              "end-date": _vm.endDate,
              "end-timezone": _vm.endTimezone,
              "is-all-day": _vm.isAllDay,
              "is-read-only": _vm.isReadOnly,
              "can-modify-all-day": _vm.canModifyAllDay,
              "user-timezone": _vm.currentUserTimezone
            },
            on: {
              updateStartDate: _vm.updateStartDate,
              updateStartTimezone: _vm.updateStartTimezone,
              updateEndDate: _vm.updateEndDate,
              updateEndTimezone: _vm.updateEndTimezone,
              toggleAllDay: _vm.toggleAllDay
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.hasLocation
        ? _c("PropertyText", {
            attrs: {
              autosize: _vm.isExpanded,
              "is-read-only": _vm.isReadOnly,
              "prop-model": _vm.rfcProps.location,
              value: _vm.location
            },
            on: { "update:value": _vm.updateLocation }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.hasDescription
        ? _c("PropertyText", {
            attrs: {
              autosize: _vm.isExpanded,
              "is-read-only": _vm.isReadOnly,
              "prop-model": _vm.rfcProps.description,
              value: _vm.description
            },
            on: { "update:value": _vm.updateDescription }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isReadOnly
        ? _c("SaveButtons", {
            staticClass: "event-popover__buttons",
            attrs: {
              "can-create-recurrence-exception":
                _vm.canCreateRecurrenceException,
              "is-new": _vm.isNew,
              "force-this-and-all-future": _vm.forceThisAndAllFuture,
              "show-more-button": true
            },
            on: {
              saveThisOnly: function($event) {
                return _vm.saveAndLeave(false)
              },
              saveThisAndAllFuture: function($event) {
                return _vm.saveAndLeave(true)
              },
              showMore: _vm.showMore
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }